const getMembersCountLabel = (count?: string) => {
  return Number(count) > 0 ? `${count} selected` : undefined;
};

export default getMembersCountLabel;
